import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TableBase} from '../table-base';
import {TYPE_DATA} from '../../../models/table';

@Component({
  selector: 'cmp-body-table',
  template: `<cmp-input-table (delayChange)="onChangeEditItem($event)"
                 *ngIf="isEdit;else onlyViewEditTab"
                 [key]="key"
                 [model]="model"></cmp-input-table>
<ng-template #onlyViewEditTab>
  <div [ngSwitch]="key.type_data" class="w-100 {{key.class}}">
    <!--********* IS BOOLEAN BY DETERMINATE ELEMENTS ************-->

    <ng-template [ngSwitchCase]="enum_type_data.BOOLEAN">

      <ng-template [ngIf]="customBoolean"
                   [ngIfElse]="defaultCheck">
        <i [class]="customBoolean.icon"></i> {{customBoolean.title}}
      </ng-template>
      <ng-template #defaultCheck>
        <span *ngIf="key.value_DROPDOWN.length;else otherCuston">
          <i class="fa fa-minus text-muted"></i>
        </span>
        <ng-template #otherCuston>
          <cmp-input-check
            [isDisabled]="true"
            [(model)]="model">
          </cmp-input-check>
        </ng-template>
      </ng-template>
    </ng-template>

    <!--********* END BOOLEAN WIDTH ARRAY OPTIONS ************-->

    <!--********* IS NUMBER ************-->
    <ng-template [ngSwitchCase]="enum_type_data.NUMBER">
      {{model | number}}
    </ng-template>
    <!--********* END NUMBER ************-->

    <!--********* IS TYPE DATE ************-->
    <ng-template [ngSwitchCase]="enum_type_data.DATE">
      {{model | date: 'short'}}
    </ng-template>
    <!--********* END TYPE DATE ************-->

    <!--********* IS DROWDOPW ************-->
    <ng-template [ngSwitchCase]="enum_type_data.DROPDOWN">
      <ng-template [ngIf]="customBoolean"
                   [ngIfElse]="defaultCheck">
        <i [class]="customBoolean.icon"></i> {{customBoolean.title}}
      </ng-template>
      <ng-template #defaultCheck>
        <span *ngIf="model">{{model}}</span>
        <i *ngIf="!model" class="fa fa-minus text-muted"></i>
      </ng-template>
    </ng-template>
    <!--********* END  DROWDOPW ************-->
    <ng-template ngSwitchDefault>
      <i *ngIf="key.icon" [class]="key.icon+ ' mr-2'"></i>
      {{model}}
    </ng-template>
  </div>
</ng-template>

`,
  styles: [``]
})
export class BodyTableComponent extends TableBase implements OnInit {
  @Output() changeRow = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
  }

  onChangeEditItem(e) {
    const obj = <any>{
      keyToData: this.key.keyData || this.key.title,
      title: this.key.title
    };

    if (this.row[this.key.keyData]) {
      obj.previous = this.row[this.key.keyData];
    }
    if (e) {
      obj.newValue = e;
    }

    if (obj.newValue !== obj.previous || this.key.type_data === TYPE_DATA.ACTION) {
      this.row[this.key.keyData] = e;
      obj['row'] = this.row;
      this.changeRow.emit(this.row);
      this.onActionItem.emit(obj);
    }
  }

  get isEdit() {
    return this.key.onAction || this.key.type_data === TYPE_DATA.ACTION;
  }
}
